import React, {ReactElement, useContext} from "react";
import {ResourceContext} from "../contexts";
import {Button} from "@mui/material";
import {PAGE_FRAGMENT_WIDTH, PD_SM, PD_XLG, PD_XLG2} from "../../shared/dimens";
import {CreateProjectHelper} from "../CreateProjectHelper";
import {ResourceSelectFragment} from "../ResourceSelect";
import {ResourceAccessRole, ResourcesFiltered, ResourceType} from "../types";
import {StyledBoxColumn} from "../../shared/StyledComponents";

export function ProjectSelectView(): ReactElement {
  const resourceContext = useContext(ResourceContext);
  return <StyledBoxColumn style={{width: "100%", maxWidth: PAGE_FRAGMENT_WIDTH}}>
    {resourceContext.accessRole !== ResourceAccessRole.LABELER
      ? <div style={{padding: PD_SM, width: "100%"}}>
        <Button
          onClick={() => CreateProjectHelper.create()}
          variant={"outlined"} style={{width: "100%", padding: `${PD_XLG}px ${PD_XLG2}px`, fontSize: "125%"}}>
          Create New Project
        </Button>
      </div>
      : null}
    <ResourceSelectFragment
      style={{width: "100%"}}
      resources={ResourcesFiltered(resourceContext.resources, {includeTypes: [ResourceType.PROJECT]})}
      selectedResource={resourceContext.selectedResource}
      setSelectedResource={(resource) => {
        if (resource) {
          resourceContext.setSelectedResource(resource);
        }
      }}
    />
  </StyledBoxColumn>;
}
